import React, { useState, useEffect } from 'react';
import { fetchWifiData } from '../data/getdata';
import '../css/BSSIDs.css';
import moreIcon from '../svg/more.svg';
import bssidIcon from '../svg/BSSIDs.svg';
import FilterSortBar from './FilterSortBarBSSIDs';
import BSSIDsDetails from './BSSIDsDetails';
import BssidsDetailsRate from './BSSIDsDetailsRate.js'; // 导入BssidsDetailsRate组件

const BSSIDs = () => {
    const [bssidData, setBSSIDData] = useState([]);
    const [otherData, setOTHERData] = useState([]);
    const [selectedBSSID, setSelectedBSSID] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [showRate, setShowRate] = useState(false); // 添加showRate状态
    const [selectedOption, setSelectedOption] = useState('signal_strength');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchedData = await fetchWifiData();
                setBSSIDData(fetchedData.Detail.bssids); // 假设BSSID数据位于fetchedData.Detail.bssids中
                setOTHERData(fetchedData.Detail);
            } catch (error) {
                console.error('Error fetching BSSID data:', error);
            }
        };

        fetchData();
    }, []);

    const handleSortChange = (option, ascending) => {
        const sortedData = [...bssidData];
        sortedData.sort((a, b) => {
            let aValue = '';
            let bValue = '';

            switch (option) {
              case 'bssid-name':
                  aValue = a.wifi_host.best_name_formatted;
                  bValue = b.wifi_host.best_name_formatted;
                  break;
              case 'SSID':
                  aValue = a.apData.ssid;
                  bValue = b.apData.ssid;
                  break;
              case 'signal_strength':
                  aValue = a.wifi_host.signal;
                  bValue = b.wifi_host.signal;
                  break;
              case 'Channel':
                  aValue = a.wifi_item.airwise_active_channels;
                  bValue = b.wifi_item.airwise_active_channels;
                  break;
              case 'Client-count':
                  aValue = a.wifi_item?.airwise_active_clients?.length ?? 0;
                  bValue = b.wifi_item?.airwise_active_clients?.length ?? 0;
                  break;
              case 'Channel-width':
                  aValue = a.apData.channel_width;
                  bValue = b.apData.channel_width;
                  break;                
              case 'SNR':
                  aValue = a.apData.snr;
                  bValue = b.apData.snr;
                  break;  
              case 'Tx-Power':
                  aValue = a.apData.beacon_tx_power_dbm;
                  bValue = b.apData.beacon_tx_power_dbm;
                  break;  
              case 'Basic-Rate':
                  aValue = a.apData.basic_rates;
                  bValue = b.apData.basic_rates;
                  break;  
              case 'QBSS-Stations': 
                  aValue = a.apData.qbss_station_count;
                  bValue = b.apData.qbss_station_count;
                  break;  
              case 'QBSS-Use':
                  aValue = a.apData?.qbss_station_count ?? 0
                  bValue = b.apData?.qbss_station_count ?? 0
                  break;  
  
              // Add more sorting options as needed
              default:
                  break;
            }
            const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);

            if (option === 'QBSS-Stations') {
                const aIsNumeric = isNumeric(aValue);
                const bIsNumeric = isNumeric(bValue);
    
                if (!aIsNumeric && !bIsNumeric) return 0; // Both are non-numeric
                if (!aIsNumeric) return 1; // aValue is non-numeric, place it at the end
                if (!bIsNumeric) return -1; // bValue is non-numeric, place it at the end
            }
    

            if (aValue < bValue) {
                return ascending ? -1 : 1;
            }
            if (aValue > bValue) {
                return ascending ? 1 : -1;
            }
            return 0;
        });

        setBSSIDData(sortedData);
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const handleBSSIDClick = (bssid) => {
        setSelectedBSSID(bssid);
        setShowDetails(true);
        setShowRate(false); // 确保显示详情时隐藏速率和性能页面
    };

    const handleReturnClick = () => {
        setShowDetails(false);
        setSelectedBSSID(null);
        setShowRate(false); // 返回时隐藏速率和性能页面
    };

    const handleRateClick = () => {
        setShowRate(true); // 显示速率和性能页面
    };

    const handleRateReturnClick = () => {
        setShowRate(false); // 返回详情页面
    };

    const renderBSSIDValue = (bssid) => {
        switch (selectedOption) {
            case 'signal_strength':
                return `${bssid.wifi_host.signal ?? '-'} dBm`;
            case 'bssid-name':
                return `${bssid.wifi_host.best_name_formatted}`;
            case 'SSID':
                return `${bssid.apData?.ssid ?? '[Hidden]'}`;
            case 'Channel':
                return `信道 ${bssid.wifi_item?.airwise_active_channels ?? 0}`;
            case 'Client-count':
                return `客户端数量：${bssid.wifi_item?.airwise_active_clients?.length ?? 0}`;
            case 'Channel-width':
                return `${bssid.apData.channel_width }`;
            case 'SNR':
                return `${bssid.apData.snr}dB`;         
            case 'Tx-Power':
                return `${bssid.apData?.beacon_tx_power_dbm ?? '--'}dBm`; 
            case 'Basic-Rate':
                return `${bssid.apData?.basic_rates}`;
            case 'QBSS-Stations':
                return `Stations:${bssid.apData?.qbss_station_count ?? '--'}`;        
            case 'QBSS-Use':
                return `${bssid.apData?.qbss_channel_util}`;                  
            default:
                return '';
        }
    };

    return (
        <div className="bssid-container">
            {!showRate && <FilterSortBar onSortChange={handleSortChange} onOptionChange={handleOptionChange} />}
            {!showDetails && (
                <div className="bssid-list">
                    {bssidData.map((bssid, index) => (
                        <div key={index} className="bssid-block" onClick={() => handleBSSIDClick(bssid)}>
                            <img src={bssidIcon} alt="bssid-icon" className="bssid-icon" /> 
                            <img src={moreIcon} alt="more-icon" className="more-icon" />
                            <div className="bssid-name">{bssid.wifi_host.best_name_formatted}</div>
                            <div className="signal_strength">{bssid.wifi_host.signal ?? '-'} dBm</div>
                            <div className="channel">{`CH：${bssid.wifi_host.channel ?? '-'}`}</div>
                            <div className="ssid">{bssid.apData.ssid ? bssid.apData.ssid : '[Hidden]' }</div>
                            <div className="bssid-value">{renderBSSIDValue(bssid)}</div>
                        </div>
                    ))}
                </div>
            )}
            {showDetails && selectedBSSID && !showRate && (
                <div className="bssid-details">
                    <BSSIDsDetails 
                        selectedBSSID={selectedBSSID} 
                        otherData={otherData} 
                        onReturn={handleReturnClick} 
                        onRateClick={handleRateClick} // 传递handleRateClick回调
                    />
                </div>
            )}
            {showRate && selectedBSSID && (
                <div className="bssid-details">
                    <BssidsDetailsRate 
                        selectedBSSID={selectedBSSID} 
                        otherData={otherData} 
                        onReturn={handleRateReturnClick} // 传递handleRateReturnClick回调
                    />
                </div>
            )}
        </div>
    );
};

export default BSSIDs;